import axios from '../../../helpers/axios'

export default {
  state:{
    addRentalAnnouncementProcess:null,
    addRentalAnnouncementSuccess:null,
    addRentalAnnouncementError:null
  },
  getters:{
    addRentalAnnouncementProcess: state => state.addRentalAnnouncementProcess,
    addRentalAnnouncementSuccess: state => state.addRentalAnnouncementSuccess,
    addRentalAnnouncementError: state => state.addRentalAnnouncementError
  },
  mutations:{
    ADD_RENTAL_ANNOUNCEMENT_PROCESS (state, payload) {
      state.addRentalAnnouncementProcess = payload
    },
    ADD_RENTAL_ANNOUNCEMENT_SUCCESS (state, payload) {
      state.addRentalAnnouncementSuccess = payload
    },
    ADD_RENTAL_ANNOUNCEMENT_ERROR (state, payload) {
      state.addRentalAnnouncementError = payload
    },
    CLEAR_ADD_RENTAL_ANNOUNCEMENT (state) {
      state.addRentalAnnouncementProcess = null
      state.addRentalAnnouncementSuccess = null
      state.addRentalAnnouncementError = null
    }
  },
  actions :{
    addRentalAnnouncement ({commit, rootState}, payload) {
      commit('CLEAR_ADD_RENTAL_ANNOUNCEMENT')
      commit('ADD_RENTAL_ANNOUNCEMENT_PROCESS', true)
      const bodyRequest = JSON.stringify({
        rentInformation: {
          name: payload.rentInformation.name,
          bedroom: payload.rentInformation.bedroom,
          bathroom: payload.rentInformation.bathroom,
          checkin: payload.rentInformation.checkin,
          checkout: payload.rentInformation.checkout,
          visitors:payload.rentInformation.visitors,
          description: payload.rentInformation.description,
          bed: payload.rentInformation.bed,
          equipments: payload.rentInformation.equipments,
          pricePerNight: payload.rentInformation.pricePerNight,
          rentalType: payload.rentInformation.rentalType
        },
        property: {
          name: payload.property.name,
          position: payload.property.name,
          propertyType: payload.property.propertyType
        }
      })
      const config = {
        method: 'post',
        url: '/rental-announcement/save-an-rental-announcement-and-property',
        headers: { 
          'Authorization': `Bearer ${rootState.user.token}`
        },
        data : bodyRequest
      }
      axios(config).then(result => {
        commit('ADD_RENTAL_ANNOUNCEMENT_PROCESS', false)
        commit('ADD_RENTAL_ANNOUNCEMENT_SUCCESS', result.data)
      })
        .catch(error => {
          commit('ADD_RENTAL_ANNOUNCEMENT_PROCESS', false)
          if (error.response) {
            commit('ADD_RENTAL_ANNOUNCEMENT_ERROR', error.response.data)
          } else if (error.request) {
            commit('ADD_RENTAL_ANNOUNCEMENT_ERROR', error.request)
          } else {
            commit('ADD_RENTAL_ANNOUNCEMENT_ERROR', error.message)
          }
          setTimeout(() => {
            commit('CLEAR_ADD_RENTAL_ANNOUNCEMENT')
          }, 3000)
        })

    }
  }
}